window.theme = window.theme || {};

theme.Counter = (function() {
  function Counter(container) {
    this.container = container;
    if(!container){
      return;
    }

    this.settings = {
      speed: 1700
    }

    const self = this;

    this.counters = this.container.querySelectorAll('[data-count]');
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          self.counters.forEach(function(countItem){
            let countTo = parseInt(countItem.dataset.count);
            let speed = self.settings.speed / countTo;
        
            if(!countTo){
              console.log('unable to find count');
              return;
            }
            self.incrementNumber(countItem,countTo,speed);
          });
          self.observer.unobserve(self.container);
        }
      });
    }, {threshold: 0.1});

    this.observer.observe(this.container);
  }

  Counter.prototype = {
    incrementNumber: function(element, count, speed) {
      let number = 0;
      const intervalId = setInterval(() => {
        if (number >= count) {
          clearInterval(intervalId);
          return;
        }
        number++;
        element.innerHTML = number;
      }, speed);
    }
  }

  return Counter;

})();

document.addEventListener('DOMContentLoaded', function() {
  const counterSectionContainers = document.querySelectorAll('.counter-text--section');
  if (!window.theme.counterSections && counterSectionContainers){
    window.theme.counterSections = []
    counterSectionContainers.forEach(function(container){
      window.theme.counterSections.push(new theme.Counter(container));
    });
  }
});
